var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#D6E4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 24C39.5 28.4183 35.9182 32 31.5 32C27.0817 32 23.5 28.4183 23.5 24C23.5 19.5817 27.0817 16 31.5 16C35.9182 16 39.5 19.5817 39.5 24Z",
    fill: "#254EDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5001 44.9999C45.5001 47.4999 41.9935 47 31.5001 47C21.0067 47 19 47.9999 19 44.9999C19 40.9999 20.6252 34 31.5001 34C42.375 34 45.5001 40.9999 45.5001 44.9999Z",
    fill: "#254EDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6fe6c8a40690e9a2e9f43a03e9780e27.svg";
export { ForwardRef as ReactComponent };